"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Tabs, TabsContent, TabsList, TabsTrigger } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsTabs() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Tabs
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A set of layered sections of content, known as tab panels, displayed one at a time.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/tabs" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Basic tabs with content panels</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Tabs defaultValue="account" className="w-full">
            <TabsList>
              <TabsTrigger value="account">Account</TabsTrigger>
              <TabsTrigger value="password">Password</TabsTrigger>
              <TabsTrigger value="settings">Settings</TabsTrigger>
            </TabsList>
            <TabsContent value="account" className="p-4">
              <Text className="text-sm text-muted-foreground">
                Manage your account settings and preferences.
              </Text>
            </TabsContent>
            <TabsContent value="password" className="p-4">
              <Text className="text-sm text-muted-foreground">
                Change your password and security settings.
              </Text>
            </TabsContent>
            <TabsContent value="settings" className="p-4">
              <Text className="text-sm text-muted-foreground">
                Configure application settings and notifications.
              </Text>
            </TabsContent>
          </Tabs>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Components</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Component</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">Tabs</td>
                <td className="py-2 text-muted-foreground">Root component managing state</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">TabsList</td>
                <td className="py-2 text-muted-foreground">Container for tab triggers</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">TabsTrigger</td>
                <td className="py-2 text-muted-foreground">Button that activates a tab panel</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">TabsContent</td>
                <td className="py-2 text-muted-foreground">Content panel for each tab</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Accessibility</CardTitle>}
          contentClassName="p-6"
        >
          <ul className="space-y-2 text-sm">
            <li>• Follows WAI-ARIA Tabs pattern</li>
            <li>• Arrow keys navigate between tabs</li>
            <li>• Tab and Shift+Tab move focus in/out of the tabs</li>
            <li>• Home/End move to first/last tab</li>
          </ul>
        </SectionCard>
      </Section>
    </>
  );
}
